import { useEffect, useState } from "react";

export interface StatusFailureEvent {
	type: "status_failure";
	serviceId: string;
	applicationId: string;
	serviceName?: string;
	error: string;
	checkedAt: string;
}

export function useStatusFailureWebSocket() {
	const [lastFailure, setLastFailure] = useState<StatusFailureEvent | null>(null);
	const [connected, setConnected] = useState(false);

	useEffect(() => {
		const protocol = location.protocol === "https:" ? "wss:" : "ws:";
		const url = `${protocol}//${location.host}/api/ws`;
		const ws = new WebSocket(url);

		ws.onopen = () => setConnected(true);
		ws.onclose = () => setConnected(false);
		ws.onmessage = (event) => {
			try {
				const data = JSON.parse(event.data as string) as StatusFailureEvent;
				if (data.type === "status_failure") {
					setLastFailure(data);
				}
			} catch {
				// ignore non-JSON or invalid messages
			}
		};

		return () => {
			ws.close();
		};
	}, []);

	return { lastFailure, setLastFailure, connected };
}
